// @flow
import * as React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { CSSTransitionGroup } from 'react-transition-group';
import Input from '../../components/Input';
import { FirstChild } from '../../helpers';

type Props = {
  isSaving: boolean,
  settings: Object,
  successMsg: string,
  errorMsg: string,
  handleSubmit: (v: Object) => void
};

const SettingsPageContentForm = (props: Props) => (
  <Form onSubmit={props.handleSubmit}>
    <h2>Hover Text</h2>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.globalIndustriesInfoHoverText
              ? props.settings.globalIndustriesInfoHoverText.description
              : ''
          }
          name="globalIndustriesInfoHoverText.value"
          label="Dashboard Global Industries Info Hover Text"
          componentClass="textarea"
          rows="3"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.globalCatchmentSetsInfoHoverText
              ? props.settings.globalCatchmentSetsInfoHoverText.description
              : ''
          }
          name="globalCatchmentSetsInfoHoverText.value"
          label="Dashboard Global Catchment Sets Info Hover Text"
          componentClass="textarea"
          rows="3"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.globalInsightSetsInfoHoverText
              ? props.settings.globalInsightSetsInfoHoverText.description
              : ''
          }
          name="globalInsightSetsInfoHoverText.value"
          label="Dashboard Global Insight Sets Info Hover Text"
          componentClass="textarea"
          rows="3"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.globalCampaignsInfoHoverText
              ? props.settings.globalCampaignsInfoHoverText.description
              : ''
          }
          name="globalCampaignsInfoHoverText.value"
          label="Dashboard Global Campaign Info Hover Text"
          componentClass="textarea"
          rows="3"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.globalCustomerInfoHoverText
              ? props.settings.globalCustomerInfoHoverText.description
              : ''
          }
          name="globalCustomerInfoHoverText.value"
          label="Dashboard Global Customer Info Hover Text"
          componentClass="textarea"
          rows="3"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.globalSettingsInfoHoverText
              ? props.settings.globalSettingsInfoHoverText.description
              : ''
          }
          name="globalSettingsInfoHoverText.value"
          label="Dashboard Global Settings Info Hover Text"
          componentClass="textarea"
          rows="3"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.globalBookingsInfoHoverText
              ? props.settings.globalBookingsInfoHoverText.description
              : ''
          }
          name="globalBookingsInfoHoverText.value"
          label="Dashboard Global Bookings Info Hover Text"
          componentClass="textarea"
          rows="3"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.customerHeadingInfoHoverText
              ? props.settings.customerHeadingInfoHoverText.description
              : ''
          }
          name="customerHeadingInfoHoverText.value"
          label="Dashboard Customer Heading Info Hover Text"
          componentClass="textarea"
          rows="3"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.customerCampaignInfoHoverText
              ? props.settings.customerCampaignInfoHoverText.description
              : ''
          }
          name="customerCampaignInfoHoverText.value"
          label="Dashboard Customer Campaigns Info Hover Text"
          componentClass="textarea"
          rows="3"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.customerCatchmentSetsInfoHoverText
              ? props.settings.customerCatchmentSetsInfoHoverText.description
              : ''
          }
          name="customerCatchmentSetsInfoHoverText.value"
          label="Dashboard Customer Catchment Sets Info Hover Text"
          componentClass="textarea"
          rows="3"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.customerSubAccountsInfoHoverText
              ? props.settings.customerSubAccountsInfoHoverText.description
              : ''
          }
          name="customerSubAccountsInfoHoverText.value"
          label="Dashboard Customer Sub Accounts Info Hover Text"
          componentClass="textarea"
          rows="3"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.customerUserInfoHoverText
              ? props.settings.customerUserInfoHoverText.description
              : ''
          }
          name="customerUserInfoHoverText.value"
          label="Dashboard Customer Users Info Hover Text"
          componentClass="textarea"
          rows="3"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.customerDetailsInfoHoverText
              ? props.settings.customerDetailsInfoHoverText.description
              : ''
          }
          name="customerDetailsInfoHoverText.value"
          label="Dashboard Customer Details Info Hover Text"
          componentClass="textarea"
          rows="3"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.customerBookingsInfoHoverText
              ? props.settings.customerBookingsInfoHoverText.description
              : ''
          }
          name="customerBookingsInfoHoverText.value"
          label="Dashboard Customer Bookings Info Hover Text"
          componentClass="textarea"
          rows="3"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.subAccountHeadingInfoHoverText
              ? props.settings.subAccountHeadingInfoHoverText.description
              : ''
          }
          name="subAccountHeadingInfoHoverText.value"
          label="Dashboard Sub-Account Heading Info Hover Text"
          componentClass="textarea"
          rows="3"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.subAccountCampaignsInfoHoverText
              ? props.settings.subAccountCampaignsInfoHoverText.description
              : ''
          }
          name="subAccountCampaignsInfoHoverText.value"
          label="Dashboard Sub-Account Campaigns Info Hover Text"
          componentClass="textarea"
          rows="3"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.subAccountUsersInfoHoverText
              ? props.settings.subAccountUsersInfoHoverText.description
              : ''
          }
          name="subAccountUsersInfoHoverText.value"
          label="Dashboard Sub-Account Users Info Hover Text"
          componentClass="textarea"
          rows="3"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.subAccountDetailsInfoHoverText
              ? props.settings.subAccountDetailsInfoHoverText.description
              : ''
          }
          name="subAccountDetailsInfoHoverText.value"
          label="Dashboard Sub-Account Details Info Hover Text"
          componentClass="textarea"
          rows="3"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.subAccountBookingsInfoHoverText
              ? props.settings
                  .subAccountDetailsInfoHoverTextsubAccountBookingsInfoHoverText
                  .description
              : ''
          }
          name="subAccountBookingsInfoHoverText.value"
          label="Dashboard Sub-Account Bookings Info Hover Text"
          componentClass="textarea"
          rows="3"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12}>
        <Button
          bsStyle="primary"
          type="submit"
          className="relative-padding"
          disabled={props.isSaving}
        >
          {props.isSaving ? 'Saving...' : 'Save'}
        </Button>
      </Col>
    </Row>
    <br />
    <Row>
      <Col sm={12}>
        <CSSTransitionGroup
          component={FirstChild}
          transitionName="fade"
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
        >
          {props.successMsg ? (
            <p key="success" className="text-success">
              {props.successMsg}
            </p>
          ) : null}
        </CSSTransitionGroup>
      </Col>
    </Row>
    {props.errorMsg && (
      <div className="alert alert-danger">{props.errorMsg}</div>
    )}
  </Form>
);

export default reduxForm({
  form: 'settingsPageContentForm'
})(SettingsPageContentForm);



// WEBPACK FOOTER //
// ./src/containers/settings/SettingsPageContentForm.js